
import Vue from 'vue';
import { ModalActions, Button, Icon } from '@descomplica/vue-components';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';
import { CourseModel } from '@descomplica/dex-models';
import { getCourseCategory } from '@/helpers/category';
import { downloadPdf } from '@/helpers/postgradMicrocertificate/downloadMicrocertificate';
import { downloadImageFromUrl } from '@/helpers/download';

export default Vue.extend({
  components: {
    ModalActions,
    Button,
    Icon,
  },
  props: {
    disciplineName: {
      type: String,
      default: '',
      required: true,
    },
    disciplineWorkload: {
      type: Number,
      default: 0,
    },
    pdfUrl: {
      type: String,
      default: '',
      required: true,
    },
    imageUrl: {
      type: String,
      default: '',
      required: true,
    },
  },
  data() {
    return {
      downloadingImage: false,
    };
  },
  computed: {
    currentCourse(): CourseModel {
      return this.$store.getters.currentCourse;
    },
  },
  methods: {
    async downloadFile(fileUrl: string, type: 'pdf' | 'png'): Promise<void> {
      if (type === 'pdf') {
        downloadPdf(fileUrl);
        this.trackButtonInteraction('download_pdf');
        this.trackDownloadFinished();
        return;
      }

      if (!this.downloadingImage) {
        this.downloadingImage = true;
        this.trackButtonInteraction('download_image');

        await downloadImageFromUrl({
          imageUrl: fileUrl,
          fileName: `Microcertificado - ${this.disciplineName}`,
        });

        this.trackDownloadFinished();
        this.downloadingImage = false;
      }
    },

    trackButtonInteraction(buttonType: 'download_image' | 'download_pdf' | 'share_linkedin'): void {
      Analytics.trackEvent(EVENT_LABELS.buttonClicked, {
        postgrad_microcertificate_sharing_and_download_modal: true,
        postgrad_microcertificate_sharing_and_download_modal_action: buttonType,
        course: this.currentCourse.name,
        category: getCourseCategory(this.currentCourse),
      });
    },

    trackDownloadFinished(): void {
      Analytics.trackEvent(EVENT_LABELS.downloadFinished, {
        postgrad_microcertificate: true,
        course: this.currentCourse.name,
        category: getCourseCategory(this.currentCourse),
      });
    },

    shareOnLinkedin(): void {
      this.trackButtonInteraction('share_linkedin');
      this.$emit('onShare');
    },
  },
});
